const keyHex = "0123456789abcdef9876543210fedcba";
const ivHex = "abcfed9876501234cbadef4321056789";

function hexToBytes(hex) {
  return Uint8Array.from(hex.match(/.{2}/g).map((byte) => parseInt(byte, 16)));
}

function fixBase64Padding(data) {
  const clean = data.replace(/[\r\n\s]/g, "");
  const mod = clean.length % 4;
  if (mod === 2) return clean + "==";
  if (mod === 3) return clean + "=";
  if (mod === 1) throw new Error("invalid base64 string");
  return clean;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
}

async function importKey(keyHex) {
  const keyBytes = hexToBytes(keyHex);
  return await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-CBC" },
    false,
    ["encrypt", "decrypt"]
  );
}

export default {
  encryptData: async function (str, encFlag = false) {
    const key = await importKey(keyHex);
    const iv = hexToBytes(ivHex);
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-CBC", iv },
      key,
      data
    );
    if (encFlag) {
      return encodeURIComponent(arrayBufferToBase64(encrypted));
    } else {
      return arrayBufferToBase64(encrypted);
    }
  },
};
